import React from 'react'
// import PropTypes from 'prop-types'

import { MainTitle, LinkText, TextContent } from '../../../Shared';

const Articles = props => {
  return (
    <div>
      <MainTitle>Articles</MainTitle>
      <TextContent>
      [P1] M. T Ha, P. N. Hoang-Nam, N. X. Long, <b> T. M. Quang </b>, "Mining Urban Traffic Condition From Crowd-Sourced Data," SN COMPUT. SCI. 1:225 (2020), ISSN 2661-8907, 
      <LinkText target='_blank' path='https://doi.org/10.1007/s42979-020-00244-6'>https://doi.org/10.1007/s42979-020-00244-6</LinkText> (16 pages).
      </TextContent>

      <TextContent>
      [P2] H. M. Tan, H. N. P. Nguyen, N. H. Phat,<b> T. M. Quang </b>, "Traffic Condition Estimation Based on Historical Data Analysis," the 8th International conference on communications
      and electronics (ICCE 2020), Jan. 2021, Phu Quoc, Vietnam (accepted). 
      <LinkText target='_blank' path='https://drive.google.com/file/d/10XQqT_7enAUfLd10wTkzIE80BIirEj7r/view?usp=sharing'> Download here </LinkText>.
      </TextContent>

      <TextContent>
      [P3] T. M. Quang, H. N. P. Nguyen, H. M. Tan, N. X. Long, “Traffic Congestion Estimation based on Crowd-sourced Data,” International Conference on Advanced Computing and Applications
      (ACOMP2019), ISBN-13: 978-1-7281-4723-9, Nha Trang, Vietnam, Nov. 27-29, 2019, pp. 1-8. 
      <LinkText target='_blank' path='https://drive.google.com/file/d/1bv8HDUyyA77vJ-Vs_Xs88qYv55O_x4gA/view?usp=sharing'> Download here </LinkText>.
      </TextContent>

      <TextContent>
      [P4] H. Nguyen G, T. Nguyen, H. L. Trung, and Q. T. Minh, “Speech-based traffic reporting: An automated data collecting approach for intelligent transportation systems,” in International
      Conference on Artificial Intelligence and Big Data in Digital Era (ICABDE 2021), pp. 671–683, Springer, 2022.
      <LinkText target='_blank' path='https://doi.org/10.1007/978-3-030-97610-1_53'>https://doi.org/10.1007/978-3-030-97610-1_53</LinkText> (13 pages).
      </TextContent>
    </div>
  )
}

Articles.propTypes = {

}

export default Articles
